import React from "react";
import "./../css/help.scss";
import { useLanguage } from "../context/LanguageContext";

interface HelpProps {
  option?: string;
  blockingAction: () => void;
  unblockingAction?: () => void;
}

const Help: React.FC<HelpProps> = ({ option, blockingAction, unblockingAction }) => {
  const { lang } = useLanguage();

  React.useEffect(() => {
    blockingAction();
    unblockingAction?.();
  }, [blockingAction, unblockingAction]);

  const commands = lang === 'en' ? [
    { name: "whoami", desc: "Execute systems architecture audit & professional manifesto." },
    { name: "hardware", desc: "Explore the hardware lab: Edge AI, IoT and electronics." },
    { name: "vision", desc: "Display roadmap for infrastructure & AI sovereignty." },
    { name: "dev --contact", desc: "Retrieve secure communication channels." },
    { name: "run --benchmark", desc: "Execute hardware performance telemetry (Edge AI)." },
    { name: "probe", desc: "What any website can see about you (data is power)." },
    { name: "version", desc: "Display current system build and kernel information." },
    { name: "lang | config --lang [en|es]", desc: "Switch language instantly (English/Español)." },
    { name: "clear | cls", desc: "Purge terminal buffer & reset interface." },
  ] : [
    { name: "whoami", desc: "Quién soy, qué hago y por qué me contratan." },
    { name: "hardware", desc: "Mi laboratorio: Edge AI, IoT y electrónica." },
    { name: "vision", desc: "Cómo trabajo y hacia dónde voy." },
    { name: "dev --contact", desc: "Cómo contactarme (email, redes)." },
    { name: "run --benchmark", desc: "Prueba divertida: mide tu equipo." },
    { name: "probe", desc: "Lo que cualquier sitio ve de ti (el dato es poder)." },
    { name: "version", desc: "Versión de este sitio." },
    { name: "lang | config --lang [en|es]", desc: "Cambia el idioma al instante (English/Español)." },
    { name: "clear | cls", desc: "Limpiar la pantalla." },
  ];

  const title = lang === 'en' ? "AVAILABLE SYSTEM COMMANDS" : "¿Qué quieres ver? Elige arriba o escribe:";
  const subtitle = lang === 'en' ? "Tip: click the buttons on top, or type a command below." : "Tip: toca los botones de arriba, o escribe un comando abajo. Empieza con whoami.";
  const colIdentifier = lang === 'en' ? "IDENTIFIER" : "Comando";
  const colDescription = lang === 'en' ? "DESCRIPTION" : "Qué hace";

  return (
    <div className="px-2 py-3 available-commands">
      <div className="help-box">
        <h6 className="help-title">{title}</h6>
        <p className="mb-3" style={{ fontSize: '0.85rem', opacity: 0.85 }}>{subtitle}</p>
        <div className="table-responsive">
          <table className="table table-borderless mb-0">
            <thead>
              <tr>
                <th>{colIdentifier}</th>
                <th>{colDescription}</th>
              </tr>
            </thead>
            <tbody>
              {commands.map((cmd, i) => (
                <tr key={i}>
                  <td className="cmd-name">{cmd.name}</td>
                  <td className="cmd-desc">{cmd.desc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Help;
